import React from 'react'

const e = React.createElement;


function Graph24H(props) {
  React.Component.constructor.call(this);

  this.state = {graph_offset:null};
}
Graph24H.prototype = Object.create(React.Component.prototype);


Graph24H.prototype.componentDidUpdate = function() {
  var canvas_wrapper = document.getElementById("graph24h-wrapper");
  var canvas = document.getElementById("canvas24h");
  if(this.state.graph_offset === null && canvas_wrapper && canvas && canvas.width > 0) {
    var max_width = canvas_wrapper.offsetWidth;
    var new_graph_offset = -(canvas.width - max_width);
    this.setState({graph_offset:new_graph_offset});
  }
}

Graph24H.prototype.render = function() {
  const data = this.props.data;
  const filtered = this.props.filtered ? this.props.filtered : null;
  var canvas = document.getElementById("canvas24h");

  if(canvas && data[0] !== undefined) {
    var ctx = canvas.getContext("2d");
    var values = {};
    data.map(function(item, i) {
      if(filtered && item.app_id !== filtered) {return;}
      var d = new Date(item.created_on);
      var now = new Date();
      var time_ago = (now.getTime() - d.getTime()) / 1000 / 60; // minutes
      if((time_ago/60) < 24) {
        var key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate()+"-"+d.getHours();
        if(values[key] === undefined) {
          values[key] = 1;
        } else {
          values[key]++;
        }
      }
    });

    var max_value = 0;
    for(var i in values) {
      if(values[i] > max_value) max_value = values[i];
    }

    var now = new Date();
    var sd = new Date(now.getTime()-(86400000)); // 24 hours in milliseconds
    var last_key = now.getFullYear()+"-"+(now.getMonth()+1)+"-"+now.getDate()+"-"+now.getHours();

    var times = {};
    for(var loop_stop = 0; loop_stop < 1;) {
      sd.setHours(sd.getHours() + 1);
      var key = sd.getFullYear()+"-"+(sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getHours();
      times[key] = 0;

      if(key === last_key) {
        loop_stop++;
      }
    }

    canvas.width = Object.keys(times).length * 37 + 6;

    ctx.fillStyle = "#72FFAA";
    ctx.textAlign = "center";
    var dates_i = 0, dates = [];
    for(var key in times) {
      if(values[key]) {
        var perc = Math.floor(values[key] / max_value * 100);
        ctx.fillRect(6+dates_i*37, 100-perc, 35, perc);

        ctx.fillStyle = "#FF669E";
        ctx.fillText(values[key], 23+dates_i*37, 94);
      }

      var label = key.split("-");
      ctx.fillStyle = "#222222";
      ctx.fillText(label[3], 23+dates_i*37, 110);

      if(dates.indexOf(label[2]) === -1) {
        ctx.fillStyle = "#bbbbbb";
        ctx.fillText(label[2], 23+dates_i*37, 120);
        dates.push(label[2]);
      }
      ctx.fillStyle = "#72FFAA";

      dates_i++;
    }
  } else if(!canvas) {
    setTimeout(function() {
      this.setState({reload:true});
    }.bind(this), 0);
  }

  return e('div', {className:"card"}, e('div', {id:"graph24h-wrapper", style:{overflow:"hidden"}}, [
    e('span', {key:"left", className:"graph-arrow", onClick:this.moveGraph.bind(this, false)}, "<"),
    e('span', {key:"right", className:"graph-arrow", onClick:this.moveGraph.bind(this, true), style:{marginLeft:"22px"}}, ">"),
    e('span', {key:"max", style:{float:"right", fontSize:"62%", opacity:".4"}}, max_value && "max. "+max_value),
    e('canvas', {key:"canvas", id:"canvas24h", width:"0px", height:"120px", style:{marginLeft:this.state.graph_offset}})
  ]));
}

Graph24H.prototype.moveGraph = function(move_right) {
  var canvas_wrapper = document.getElementById("graph24h-wrapper");
  var max_width = canvas_wrapper.offsetWidth;
  var canvas = document.getElementById("canvas24h");

  var new_offset = -120;
  var new_graph_offset = this.state.graph_offset;
  if(canvas.width > 0) {
    if(!move_right && new_graph_offset < 0) {
      new_graph_offset = this.state.graph_offset - new_offset;
      if(new_graph_offset > 0) new_graph_offset = 0;
    }
    if(move_right && canvas.width + this.state.graph_offset > max_width) {
      new_graph_offset = this.state.graph_offset + new_offset;
      if(canvas.width + new_graph_offset < max_width) new_graph_offset = -(canvas.width - max_width);
    }
  }
  this.setState({graph_offset:new_graph_offset});
}


export default Graph24H



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Graph24H.js
// module id = 190
// module chunks = 0